export const amountFormatDecimalFun = (
  text: string | number | any,
  stateSetter: (val: string | number | any) => void,
) => {
  // Remove non-digits
  const numeric = text.replace(/\D/g, '');

  if (!numeric) {
    stateSetter('');
    return;
  }

  // Auto-insert decimal
  const len = numeric.length;

  let formatted = '';

  if (len === 1) {
    formatted = '0.0' + numeric;
  } else if (len === 2) {
    formatted = '0.' + numeric;
  } else {
    const whole = numeric.slice(0, -2);
    const decimal = numeric.slice(-2);
    formatted = `${parseInt(whole, 10)}.${decimal}`;
  }
  stateSetter(formatted);
};

export const amountKeyPadFormatDecimal = (digits: string) => {
  // Ensure only digits
const numeric = digits.replace(/\D/g, '');

if (!numeric) {
  return;
}

// Auto-insert decimal
const len = numeric.length;

let formatted = '';

if (len === 1) {
  formatted = '0.0' + numeric;
} else if (len === 2) {
  formatted = '0.' + numeric;
} else {
  const whole = numeric.slice(0, -2);
  const decimal = numeric.slice(-2);
  formatted = `${parseInt(whole, 10)}.${decimal}`;
}
console.log('formatted => ', formatted);
return formatted;
};

export const kgInputFormatDecimalFun = (
  text: string | number | any,
  stateSetter: (val: string | number | any) => void,
) => {
  // Remove non-digits
  const numeric = String(text).replace(/\D/g, '');

  if (!numeric) {
    stateSetter('');
    return;
  }

  const len = numeric.length;
  let formatted = '';

  if (len === 1) {
    formatted = '0.00' + numeric;
  } else if (len === 2) {
    formatted = '0.0' + numeric;
  } else if (len === 3) {
    formatted = '0.' + numeric;
  } else {
    const whole = numeric.slice(0, -3);
    const decimal = numeric.slice(-3);
    formatted = `${parseInt(whole, 10)}.${decimal}`;
  }

  stateSetter(formatted);
};

export const kgKeypadFormatDecimalFun = (digits: string) => {
  // Ensure only digits
  const clean = digits.replace(/\D/g, '');

  if (clean.length === 0) return '0.000';
  if (clean.length === 1) return `0.00${clean}`;
  if (clean.length === 2) return `0.0${clean}`;
  if (clean.length === 3) return `0.${clean}`;

  const whole = clean.slice(0, -3);
  const decimal = clean.slice(-3);
  return `${parseInt(whole, 10)}.${decimal}`;
};

export const currencyFormat = (value: any) => {
  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    style: 'decimal', // no currency symbol
  });
  return formatter.format(value);
};
